import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import useStyles from "../../hooks/useStyles";
import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";

export default function Android(props: {
  minVersion?: string | number;
  style?: React.CSSProperties;
}) {
  const { isSmallLayout } = useWindowDimensions();
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.android}
        style={isSmallLayout ? useStyles.iconSmall : useStyles.iconLarge}
        alt={PlatformType.android}
      />
      <h3>{props?.minVersion}</h3>
    </div>
  );
}
